import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import type { GeoCountryModel } from '@models/types'

import { generateUrls } from '@hooks/useGeoCountry'

const generateTabBarItems = (geoCountry: GeoCountryModel) => {
  const urls = generateUrls(geoCountry)
  const { editGeoCountryUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editGeoCountryUrl,
      key: 'details',
      title: geoCountry?.title || 'Country Details',
    },
  ]
}

export default generateTabBarItems
